export const GOOGLE_AUTOCOMPLETE_API_KEY = 'AIzaSyAiECxaLCtZmmuxzo-8Hj0zFOS6kObKUsA';